// import sidebar from '@/config/sidebars/geobooster'
// import createVueApp from '@/common/create_app'

Styxie.Initializers.MobileBusinesses = {
  // Phase 1: Businesses Index
  // index: async(props) => { ... }

  // Phase 1: Business New
  // new: async(props) => { ... }

  // Phase 3: Dashboard
  // dashboard: async(props) => { ... }

  // Phase 6: Business Settings
  // edit: async(props) => { ... }

  // Phase 6: Business Reporting
  // show: async(props) => { ... }
}
